import { Injectable } from '@angular/core';

import type { AuthorisationStrategy } from '@core/http-legacy';
@Injectable()
export class TellentClientAuthStrategy implements AuthorisationStrategy {
  public appConfig: any;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onAuthorizationFailed(response: any): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onForbidden(error: any, companyId: number | undefined, url: string | undefined): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onUnauthorized(error: any): void {}
}
